import { memo } from 'react';

interface RainAnimationProps {
  /** Animation duration in seconds (default: 1.2) */
  duration?: number;
  /** Delay before animation starts in seconds (default: 0) */
  delay?: number;
  /** Horizontal movement distance (default: 1, positive = left to right) */
  moveX?: number;
  /** Vertical movement distance (default: 8) */
  moveY?: number;
}

function RainAnimation({
  duration = 1.2,
  delay = 0,
  moveX = 1,
  moveY = 8,
}: RainAnimationProps) {
  return (
    <>
      {/* Opacity: fade in, hold, fade out */}
      <animate
        attributeName="opacity"
        values="0; 1; 1; 0"
        keyTimes="0; 0.15; 0.6; 1"
        dur={`${duration}s`}
        begin={`${delay}s`}
        repeatCount="indefinite"
        calcMode="spline"
        keySplines="0.3 0 0.7 1; 0.5 0 0.5 1; 0.3 0 0.7 1"
      />
      {/* Downward diagonal motion */}
      <animateMotion
        path={`M0,0 L${moveX},${moveY}`}
        dur={`${duration}s`}
        begin={`${delay}s`}
        repeatCount="indefinite"
        calcMode="spline"
        keySplines="0.4 0 0.6 1"
      />
    </>
  );
}

export default memo(RainAnimation);
